 
const EMAIL_REGULAR_EXPRESION = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export const emailChecker = (value: string) => EMAIL_REGULAR_EXPRESION.test(value);

/**
 * Formatea un número de teléfono al formato de Estados Unidos +1XXXXXXXXXX
 * @param phoneNumber - El número de teléfono en cualquier formato
 * @returns El número formateado como +1XXXXXXXXXX o el string original si no es válido
 */
export const formatUSPhoneNumber = (phoneNumber: string): string => {
  // Remover todos los caracteres que no sean dígitos
  const digitsOnly = phoneNumber.replace(/\D/g, '');
  
  // Si ya tiene 11 dígitos y empieza con 1, usar esos 11 dígitos
  if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
    return `+${digitsOnly}`;
  }
  
  // Si tiene exactamente 10 dígitos, agregar el código de país 1
  if (digitsOnly.length === 10) {
    return `+1${digitsOnly}`;
  }
  
  // Si no es válido, devolver el original
  return phoneNumber;
};
